import React, { useState, useRef } from "react";
import { Box, TextField, Autocomplete } from "@mui/material";
import { countries } from "../data/countries";

export default function PhoneInput({
  value,
  countryCode,
  onChange,
  error = false,
  helperText = "",
  width = "100%",
}) {
  const inputRef = useRef(null);

  // Set initial selected country
  const [selectedCountry, setSelectedCountry] = useState(
    countries.find((c) => c.phone === countryCode) ||
      countries.find((c) => c.code === "AE")
  );

  // Handle phone input changes
  const handlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    const max = Number(selectedCountry.maxlength) || 10;
    const phone = numericValue.slice(0, max);
    onChange(`+${selectedCountry.phone}`, phone);
 
  };

  // Handle country code selection
  const handleCountryChange = (e, newValue) => {
    setSelectedCountry(newValue);
    onChange(newValue.phone, "");
    inputRef.current.value = `+${newValue.phone}`;
  };

  return (
    <Box display="flex" width={width}>
      {/* Country Selector */}
      <Autocomplete
        disableClearable
        options={countries}
        value={selectedCountry}
        onChange={handleCountryChange}
        getOptionLabel={(option) => `${option.code} (+${option.phone})`}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            {option.code} (+{option.phone})
          </Box>
        )}
        sx={{
          width: "40%",
          "& .MuiOutlinedInput-root": {
            borderRadius: "50px 0 0 50px",
            backgroundColor: "#fff",
            "& fieldset": { borderColor: "#ccc" },
            "&:hover fieldset": { borderColor: "#999" },
            "&.Mui-focused fieldset": { borderColor: "#1976d2" },
          },
          "& .MuiInputBase-input": {
            fontSize: 15,
            pl: 1.5,
          },
        }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
      />

      {/* Phone Input */}
      <TextField
        inputRef={inputRef}
        fullWidth
        placeholder="Enter your contact number"
        value={value}
        onChange={handlePhoneChange}
        inputProps={{ maxLength: selectedCountry.maxlength }}
        error={error}
        helperText={helperText}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "0 50px 50px 0",
            backgroundColor: "#fff",
            "& fieldset": { borderColor: "#ccc" },
            "&:hover fieldset": { borderColor: "#999" },
            "&.Mui-focused fieldset": { borderColor: "#1976d2" },
          },
          "& .MuiInputBase-input": {
            fontSize: 15,
            pl: 2,
          },
          "& .MuiFormHelperText-root": {
            ml: 1.5,
            mt: 0.5,
          },
        }}
      />
    </Box>
  );
}
